import React, {useState} from 'react';
import {Button, Menu} from '@material-ui/core';
import {AdditionalFilterProperty} from 'Shared/components/PagedView/PagedView';
import getFilterComponent from 'Shared/components/PagedView/Filter';

type AdditionalFiltersButtonProps = {
  additionalFilterProperties: AdditionalFilterProperty[];
};

const AdditionalFiltersButton = (props: AdditionalFiltersButtonProps) => {
  const {additionalFilterProperties} = props;
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | undefined>(undefined);

  return (
    <>
      <Button onClick={e => setMenuAnchor(e.currentTarget)} color="primary">
        Additional Filters
      </Button>
      <Menu
        classes={{paper: 'table-filter-menu'}}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(undefined)}
        open={Boolean(menuAnchor)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        getContentAnchorEl={null}
      >
        {additionalFilterProperties.map(({title, filter}) => getFilterComponent(title, filter))}
      </Menu>
    </>
  );
};

export default AdditionalFiltersButton;
